module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": "500",
      "transition": "v-fade-transition",
      "fullscreen": _vm.$vuetify.breakpoint.smAndDown,
      "persistent": "",
      "hide-overlay": false,
      "scrollable": ""
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "dialog-container",
    style: ({
      height: _vm.dialogHeight
    })
  }, [_c('div', {
    staticClass: "dialog-header"
  }, [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "20px",
      "right": "20px",
      "text-align": "right"
    }
  }, [_c('transition', {
    attrs: {
      "name": "x-slow-fade"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.primaryImage),
      expression: "primaryImage"
    }],
    staticClass: "round",
    staticStyle: {
      "max-width": "50px"
    },
    attrs: {
      "src": _vm.primaryImage
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "x-slow-fade"
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.secondaryImage),
      expression: "secondaryImage"
    }],
    staticClass: "round",
    staticStyle: {
      "max-width": "50px"
    },
    attrs: {
      "src": _vm.secondaryImage
    }
  })])], 1), _vm._v(" "), _c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.title))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-body pa-3"
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    ref: "fullNames",
    attrs: {
      "rules": _vm.namesRules,
      "label": "First and Last Names",
      "hint": _vm.fullNamesHint
    },
    on: {
      "blur": _vm.cleanNames
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.calculateNames($event)
      }
    },
    model: {
      value: (_vm.fullNames),
      callback: function($$v) {
        _vm.fullNames = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "fullNames"
    }
  }), _vm._v(" "), _c('UniqueContactEnforcer', {
    ref: "enforcer1",
    attrs: {
      "contact": _vm.primaryContactName
    }
  }), _vm._v(" "), _c('UniqueContactEnforcer', {
    ref: "enforcer2",
    attrs: {
      "contact": _vm.secondaryContactName
    }
  }), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-top": "-4px"
    },
    attrs: {
      "wrap": ""
    }
  }, [(_vm.couple) ? _c('v-col', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.primaryMobileLabel,
      "prepend-icon": "phone"
    },
    model: {
      value: (_vm.primaryMobile),
      callback: function($$v) {
        _vm.primaryMobile = $$v
      },
      expression: "primaryMobile"
    }
  })], 1) : _c('v-col', [_c('v-text-field', {
    attrs: {
      "label": _vm.primaryMobileLabel,
      "prepend-icon": "phone"
    },
    model: {
      value: (_vm.primaryMobile),
      callback: function($$v) {
        _vm.primaryMobile = $$v
      },
      expression: "primaryMobile"
    }
  })], 1), _vm._v(" "), (_vm.couple) ? _c('v-col', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.secondaryMobileLabel,
      "prepend-icon": "phone"
    },
    model: {
      value: (_vm.secondaryMobile),
      callback: function($$v) {
        _vm.secondaryMobile = $$v
      },
      expression: "secondaryMobile"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', [_c('v-col', [_c('EmailBox', {
    ref: "primaryEmail",
    attrs: {
      "icon": "mail_outline",
      "label": _vm.primaryEmailLabel
    },
    model: {
      value: (_vm.primaryEmail),
      callback: function($$v) {
        _vm.primaryEmail = $$v
      },
      expression: "primaryEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', [(_vm.secondaryFirstName) ? _c('v-col', [_c('EmailBox', {
    ref: "secondaryEmail",
    attrs: {
      "icon": "mail_outline",
      "label": _vm.secondaryEmailLabel
    },
    model: {
      value: (_vm.secondaryEmail),
      callback: function($$v) {
        _vm.secondaryEmail = $$v
      },
      expression: "secondaryEmail"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rules": _vm.requiredRules,
      "label": "Transaction Name"
    },
    model: {
      value: (_vm.transactionName),
      callback: function($$v) {
        _vm.transactionName = $$v
      },
      expression: "transactionName"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.transactionTemplates,
      "label": "Template",
      "item-value": "meta.key",
      "item-text": "description"
    },
    model: {
      value: (_vm.masterKey),
      callback: function($$v) {
        _vm.masterKey = $$v
      },
      expression: "masterKey"
    }
  }), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "items": _vm.officesList,
      "label": "Office",
      "item-value": "meta.key",
      "item-text": "name"
    },
    model: {
      value: (_vm.tenantKey),
      callback: function($$v) {
        _vm.tenantKey = $$v
      },
      expression: "tenantKey"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer"
  }, [_c('v-tooltip', {
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticStyle: {
            "float": "left",
            "margin-right": "8px"
          },
          attrs: {
            "outlined": "",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return _vm.clickedSave('Checklist')
            }
          }
        }, on), [_c('v-icon', [_vm._v("mdi-format-list-checks")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Save and go to checklist")])]), _vm._v(" "), _c('v-tooltip', {
    attrs: {
      "right": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          staticStyle: {
            "float": "left"
          },
          attrs: {
            "outlined": "",
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return _vm.clickedSave('Transaction')
            }
          }
        }, on), [_c('v-icon', [_vm._v("mdi-television-guide")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Save and go to transaction")])]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickedCancel($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clickedSave($event)
      }
    }
  }, [_vm._v("Save")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ed66d06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/AddClients.vue
// module id = 2596
// module chunks = 1